import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { defer, from, lastValueFrom, Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';
import { MetaService } from 'src/app/shared/services/meta.service';

const GOOGLE_MAPS_API_KEY = 'AIzaSyC7hth_jfXr7qFo3k6G0drhtlegXJfAar4';

/** Installs Google's Dynamic Library Import bootstrap. */
function bootstrapGoogleMaps(apiKey: string): void {
	const googleApi = ((window as any).google ??= {});
	const mapsApi = (googleApi.maps ??= {});

	if (mapsApi.importLibrary) {
		return;
	}

	const requestedLibraries = new Set<string>();
	let loadPromise: Promise<void> | undefined;
	const load = (): Promise<void> => loadPromise ??= new Promise((resolve, reject) => {
		const script = document.createElement('script');
		const params = new URLSearchParams({
			key: apiKey,
			v: 'weekly',
			loading: 'async',
			callback: 'google.maps.__ib__'
		});

		params.set('libraries', Array.from(requestedLibraries).join(','));
		mapsApi.__ib__ = resolve;
		script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
		script.async = true;
		script.onerror = () => reject(new Error('Google Maps JavaScript API could not load.'));
		document.head.appendChild(script);
	});

	mapsApi.importLibrary = (library: string, ...args: unknown[]) => {
		requestedLibraries.add(library);
		return load().then(() => mapsApi.importLibrary(library, ...args));
	};
}


@Component({
    selector: 'pages-contact-one',
    templateUrl: './contact-one.component.html',
    styleUrls: ['./contact-one.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ContactOnePageComponent implements OnInit {
	apiLoaded: Observable<boolean>;
	public phone = '';
	public email = '';
	public address = '';
	public working_hours = '';
	public working_days = '';
	public page_elements = [];
	public weekend = '';
	public contact_info = '';
	public imageName = '';
	public imageURL = '';
	public storesss:any = [];
	public domainName:string;

	

	center?: google.maps.LatLngLiteral;
	  

	
  
	constructor(
		public apiService: ApiService,
		private titleService: Title,
		private meta: MetaService,
		private changeDetectorRef: ChangeDetectorRef
	) {
		this.apiLoaded = defer(() => {
			if (typeof window === 'undefined') {
				return of(false);
			}

			bootstrapGoogleMaps(GOOGLE_MAPS_API_KEY);

			return from(Promise.all([
				google.maps.importLibrary('maps'),
				google.maps.importLibrary('marker')
			])).pipe(
				map(() => true),
				catchError(() => of(false))
			);
		}).pipe(shareReplay({ bufferSize: 1, refCount: false }));
	}
	
	async ngOnInit(): Promise<void> {			
		this.titleService.setTitle('Contact Us');	
		if (typeof window !== 'undefined') {
			this.domainName = window.location.hostname;
			if(this.apiService.db_conn_string == null || this.apiService.db_conn_string == ''){
				await this.apiService.fetchDBconnStringPromise();
			}
			await this.apiService.storeParams();

			const lat = Number(this.apiService.lat);
			const lng = Number(this.apiService.long);
			if (Number.isFinite(lat) && Number.isFinite(lng)) {
				this.center = { lat, lng };
			}
		}
		let sb:string = 'SELECT * ';
		sb+= 'FROM WAREHOUSES ';
		sb+= 'WHERE DELETEDFLAG=0 ';
		sb += "AND WH_Web_Description IS NOT NULL ";
		sb += "AND LTRIM(RTRIM(WH_Web_Description)) <> '' ";
	    this.storesss = await lastValueFrom(this.apiService.execSqlQueryPromise(sb));
	   	this.apiService.stores = this.storesss;	  					
		await this.apiService.getPageContactElements();
		this.weekend = this.apiService.weekendContact;
		this.contact_info = this.apiService.contact_info;
		this.phone = this.apiService.phone;
		this.email = this.apiService.email;
		this.address = this.apiService.address;
		this.working_hours = this.apiService.working_hoursContact;
		this.working_days = this.apiService.working_daysContact;	
		this.imageName = this.apiService.imageNameContact;
		this.imageURL = environment.Images_Path+"/" + this.apiService.img_folder + "/contact/"+(this.imageName || 'no-img.png');
		this.meta.updatePageMetaTags(this.domainName,'Contact');	
		this.changeDetectorRef.markForCheck();
		
	}

	async sendEmail(event:any){
		event.preventDefault();
		let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		let name = (<HTMLInputElement>document.getElementById("cname")).value;
		let subject = (<HTMLInputElement>document.getElementById("csubject")).value;
		let message = (<HTMLInputElement>document.getElementById("cmessage")).value;
		let clients_email = (<HTMLInputElement>document.getElementById("cemail")).value;
		let phone = (<HTMLInputElement>document.getElementById("cphone")).value;
		//check if all required fields are valid and then the email
		if( name === '' || this.email === '' || message === ''){
			this.apiService.popupMsg("Required Fields Empty","Required fields (*) \n must not be left empty","info");
		}
		else if(!clients_email.match(mailformat) ){
			this.apiService.popupMsg("Wrong Email Format","Email format be like exa@gmail.com","info");
		}
		else{
			let res:any = await lastValueFrom(this.apiService.sendContactEmail(name,clients_email,phone,subject,message));
			if(res === "success"){
				this.apiService.popupMsg("Your email has been sent successfully","We will get back to you \n as soon as possible","success");
				this.clearFields();
			}
			else{
				this.apiService.popupMsg("Ooops something went wrong","Please try again later","wrong");
			}
		}		
	}

	clearFields(){
		(<HTMLInputElement>document.getElementById("cname")).value ='';
		(<HTMLInputElement>document.getElementById("csubject")).value ='';
		(<HTMLInputElement>document.getElementById("cmessage")).value='';
		(<HTMLInputElement>document.getElementById("cemail")).value='';
		(<HTMLInputElement>document.getElementById("cphone")).value='';
	}

}
